(() => {
'use strict';
const data = JSON.parse(document.getElementById('everyday-data').textContent);
const root = data.root || '/';
const $ = selector => document.querySelector(selector);
const $$ = selector => [...document.querySelectorAll(selector)];
let product = data.product;
let selectedId = Number(data.selectedId);
let stock = data.stock || [];
let dustpans = (data.dustpans || []).filter(Boolean);
let dustpan = null;
let busy = false;
let verified = false;
let failed = false;
let refreshPromise;
let photoMode = 'home';
const money = amount => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:data.currency}).format(amount / 100);
const variant = () => product?.variants?.find(v => Number(v.id) === selectedId);
const panVariant = () => dustpan?.variants?.find(v => v.available);
const pairSelected = () => !!$('[data-dustpan]:checked')?.value;
const preorder = v => !!stock.find(s => Number(s.id) === Number(v?.id))?.preorder;
const stockText = v => !v ? 'Unavailable' : !v.available ? 'Sold out' : preorder(v) ? 'Available to pre-order' : 'In stock';
const setMessage = value => { $('[data-cart-message]').textContent = value; $('[data-cart-help]').hidden = !value || value.startsWith('Added'); };
async function jsonRequest(path, options = {}) {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 12000);
  try {
    const response = await fetch(path, {cache:'no-store',...options,signal:controller.signal});
    const result = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(result.description || result.message || 'Unable to reach the store. Please try again.');
    return result;
  } finally { clearTimeout(timeout); }
}
const photoScenes = {home:'kitchen',product:'product',detail:'detail',pantry:'pantry',threshold:'threshold'};
const photoLabels = {home:'at home in the kitchen',product:'the full-size broom',detail:'natural fibers, up close',pantry:'a place in the pantry',threshold:'by the garden doorway'};
function selectedImages() {
  return data.images?.[variant()?.option1?.toLowerCase()] || {};
}
function applyScene(img, scene, color) {
  const src = selectedImages()[scene];
  if (!src) return;
  // Clear responsive sources too, so a browser cannot keep showing the previous color.
  img.removeAttribute('srcset');
  if (img.getAttribute('src') !== src) img.setAttribute('src', src);
  img.alt = (img.dataset.altTemplate || 'The {color} Everyday Broom').replace('{color}',color);
}
function renderPhoto() {
  const v = variant();
  if (!v) return;
  const scene = photoScenes[photoMode];
  const img = $('#hero-photo');
  img.dataset.broomScene = scene;
  img.dataset.mode = photoMode;
  img.dataset.altTemplate = 'The {color} Everyday Broom, ' + photoLabels[photoMode];
  applyScene(img,scene,v.title.toLowerCase());
  $('[data-photo-caption]').textContent = v.title + ' · ' + photoLabels[photoMode] + '.';
  $('[data-photo-index]').textContent = ({home:'01',product:'02',detail:'03',pantry:'04',threshold:'05'}[photoMode]) + ' / 05';
  $$('.gallery-switch button').forEach(b => b.setAttribute('aria-pressed',String(b.dataset.photo === photoMode)));
  $('.photo-label').hidden = photoMode !== 'home';
}
function renderSiteImages() {
  const v = variant();
  if (!v) return;
  $$('[data-broom-scene]').forEach(img => applyScene(img,img.dataset.broomScene,v.title.toLowerCase()));
  renderPhoto();
}
function render() {
  const v = variant();
  const pan = panVariant();
  const pair = pairSelected();
  const total = (v?.price || 0) + (pair ? pan?.price || 0 : 0);
  $$('[data-color]').forEach(button => {
    const option = product?.variants?.find(item => String(item.id) === button.dataset.color);
    button.setAttribute('aria-pressed', String(Number(button.dataset.color) === selectedId));
    button.dataset.unavailable = String(!option?.available);
    button.disabled = busy;
    button.setAttribute('aria-label', option ? option.title + ', ' + money(option.price) + ', ' + stockText(option) : 'Unavailable color');
    const optionPrice = button.querySelector('[data-option-price]');
    if (optionPrice) optionPrice.textContent = option ? money(option.price) : 'Unavailable';
  });
  $$('[data-broom-price]').forEach(el => el.textContent = v ? money(v.price) : 'Unavailable');
  $('[data-stock]').textContent = failed ? 'Availability not confirmed' : verified ? stockText(v) : 'Checking availability…';
  $('[data-sticky-summary]').textContent = v ? v.title + (pair ? ' + dustpan' : '') + ' · ' + money(total) : 'Unavailable';
  $$('[data-add]').forEach(button => {
    button.disabled = busy || (!failed && (!verified || !v?.available || (pair && !pan)));
    button.classList.toggle('is-sold-out',verified && !v?.available);
    button.textContent = busy ? 'Adding to your bag…' : failed ? 'Retry availability ↻' : !verified ? 'Checking availability…' : !v?.available ? 'Sold out' : (preorder(v) ? 'Pre-order' : pair ? 'Add the pair' : 'Add to bag') + ' — ' + money(total) + ' ↗';
  });
  $$('[data-dustpan]').forEach(input => {
    const option = dustpans.find(p => p.handle === input.value);
    const available = option?.variants?.find(v => v.available);
    input.disabled = busy || (!!input.value && !available);
    const price = $('[data-dustpan-price="' + input.value + '"]');
    if (price) price.textContent = available ? '+ ' + money(available.price) : 'Currently unavailable';
  });
  $('[data-pair-total]').textContent = pair && v ? 'Your pair: ' + v.title + ' broom + ' + dustpan.title.split(' | ')[0] + ' · ' + money(total) : '';

}
async function refresh() {
  if (refreshPromise) return refreshPromise;
  refreshPromise = (async () => {
    try {
      const [fresh, availability] = await Promise.all([
        jsonRequest(root + 'products/the-everyday-broom.js?_=' + Date.now()),
        jsonRequest(root + 'products/the-everyday-broom?view=rarely-waitlist-json&_=' + Date.now())
      ]);
      if (!Array.isArray(fresh.variants) || !fresh.variants.length || !Array.isArray(availability.variants)) throw new Error('Availability could not be verified.');
      product = fresh; stock = availability.variants; verified = true; failed = false;
      render(); return true;
    } catch (error) {
      verified = false; failed = true; render();
      setMessage('We could not confirm current availability. Please retry, or visit the product page below.');
      return false;
    } finally { refreshPromise = null; }
  })();
  return refreshPromise;
}
async function add() {
  if (busy) return;
  if (failed) { setMessage(''); await refresh(); return; }
  const oldPrice = variant()?.price;
  busy = true; setMessage(''); render();
  let posted = false;
  try {
    if (!await refresh()) return;
    const v = variant();
    if (!v?.available) { setMessage('This color is no longer available. Please choose another color.'); return; }
    if (oldPrice !== v.price) { setMessage('The price has changed. Please review the updated price and add again.'); return; }
    const items = [{id:v.id,quantity:1}];
    let pan;
    if (pairSelected()) {
      const oldPanPrice = panVariant()?.price;
      dustpan = await jsonRequest(root + 'products/' + dustpan.handle + '.js?_=' + Date.now());
      dustpans = dustpans.map(p => p.handle === dustpan.handle ? dustpan : p);
      pan = panVariant();
      if (!pan) { $('[data-dustpan][value=""]').checked = true; setMessage('The dustpan is no longer available. Review your broom selection and add again.'); return; }
      if (oldPanPrice !== pan.price) { setMessage('The dustpan price has changed. Please review the updated total and add again.'); return; }
      items.push({id:pan.id,quantity:1});
    }
    posted = true;
    const result = await jsonRequest(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
    if (!Array.isArray(result.items) || !items.every(item => result.items.some(added => Number(added.variant_id || added.id) === Number(item.id)))) throw new Error('Please check your bag to confirm what was added.');
    // Tracking must never turn a successful cart add into an apparent failure.
    try {
      const value = items.reduce((sum,item) => sum + (Number(item.id) === Number(v.id) ? v.price : pan.price),0) / 100;
      window.__rarelyBroomMetaFallback?.('AddToCart',{content_name:'The Everyday Broom - ' + v.title,content_ids:items.map(i=>String(i.id)),content_type:'product',value,currency:data.currency});
      if (typeof window.gtag === 'function') window.gtag('event','add_to_cart',{currency:data.currency,value,transport_type:'beacon',items:items.map(i=>({item_id:String(i.id),item_name:Number(i.id)===Number(v.id)?'The Everyday Broom - '+v.title:dustpan.title,price:(Number(i.id)===Number(v.id)?v.price:pan.price)/100,quantity:1}))});
    } catch (trackingError) { /* The cart addition is already confirmed. */ }
    setMessage('Added to your bag. Opening your bag…');
    $$('[data-add]').forEach(button => { button.textContent = 'Added ✓'; });
    window.location.assign(root + 'cart');
    return;
  } catch (error) {
    setMessage(posted && (error.name === 'AbortError' || error instanceof TypeError) ? 'The connection was interrupted. Check your bag before trying again to avoid adding twice.' : error.message || 'Could not add your selection. Please try again.');
  } finally { busy = false; render(); }
}
$$('[data-color]').forEach(button => button.addEventListener('click',() => {
  if (busy) return;
  selectedId = Number(button.dataset.color);
  setMessage(''); render(); renderSiteImages();
}));
$$('[data-photo]').forEach(button => button.addEventListener('click',() => { photoMode = button.dataset.photo; renderPhoto(); }));
$$('[data-add]').forEach(button => button.addEventListener('click',add));
$$('[data-dustpan]').forEach(input => input.addEventListener('change',() => { dustpan = dustpans.find(p => p.handle === input.value) || null; setMessage(''); render(); }));
const sticky = $('[data-sticky]');
if ('IntersectionObserver' in window) new IntersectionObserver(entries => {
  sticky.hidden = entries[0].isIntersecting;
},{threshold:0}).observe($('#purchase'));
render(); renderSiteImages(); refresh();
window.addEventListener('pageshow',() => { if (!busy) refresh(); });
document.addEventListener('visibilitychange',() => { if (!document.hidden && !busy) refresh(); });
})();

